import React from "react";
import GeneralInformationCreditOverview from "./GeneralInformationCreditOverview";
import ProgramVelocityLimitOverview from "./ProgramVelocityLimitOverview";
import { DataNotFound } from "../../../../Components/SharedComponent/ReviewSummarySectionNotFound/DataNotFound";

const ProgramFeaturesCreditOverview = ({ data }) => {
  if (!data) return <DataNotFound />;
  return (
    <React.Fragment>
      <GeneralInformationCreditOverview data={data} />
      <div className="mb-16"></div>
      <ProgramVelocityLimitOverview data={data} />
    </React.Fragment>
  );
};
export default ProgramFeaturesCreditOverview;
